import { makeStyles } from '@material-ui/core/styles';
import { pxToRem } from '../../../../styles/themes/vad/constants';
import get from 'lodash/get';

const useStyles = makeStyles(theme => {
  const { paddingLR } = theme.mixins;
  return {
    root: {
      [theme.breakpoints.up('lg')]: {
        paddingTop: pxToRem(96),
        ...paddingLR('5.5%'),
        paddingBottom: pxToRem(88),
        backgroundColor: '#FFFFF',
      },
      [theme.breakpoints.down('lg')]: {
        paddingTop: pxToRem(28),
        ...paddingLR(`${pxToRem(24)}`, `${pxToRem(24)}`),
        paddingBottom: pxToRem(20),
        backgroundColor: '#FFFFF',
      },
      '& input[type = number]::-webkit-inner-spin-button, & input[type = number]::-webkit-outer-spin-button': {
        '-webkitAappearance': 'none',
        '-mozAppearance': 'none',
        appearance: 'none',
        margin: 0,
      },
      'input[type=number]': {
        '-mozAppearance': 'textfield',
      },
    },
  };
});
export default useStyles;
